import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { Clock, Shield } from "lucide-react";
import * as tests from "./testDefinitions";

export const EmployeesSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Employees</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Clock}
          iconColor="text-blue-600"
          title="Timeclock System"
          tests={tests.timeclockSystemTests}
          results={testResults.timeclockSystem}
        />
        <TestSubsection
          icon={Shield}
          iconColor="text-purple-600"
          title="2FA Security"
          tests={tests.twoFactorSecurityTests}
          results={testResults.twoFactorSecurity}
        />
      </CardContent>
    </Card>
  );
};
